import { UseFormReturn } from "react-hook-form";
import { FeedbackFormType } from "./types";
import { Form, FormControl, FormField, FormItem } from "../ui/form.tsx";
import { StarInput } from "../inputs/StarInput";
import TextareaWithLabel from "../inputs/TextareaWithLabel";
import { Label } from "../ui/label.tsx";

type Props = {
    feedbackForm: UseFormReturn<FeedbackFormType>,
}

const FeedbackForm = ({ feedbackForm }: Props) => {
  return (
    <Form {...feedbackForm}>
      <form className="py-4">
        <div className="flex items-center w-full justify-between">
          <Label>Help us improve siAi</Label>
          <FormField
            control={feedbackForm.control}
            name="stars"
            render={({ field }) => (
              <FormItem>
                <FormControl>
                  <StarInput value={field.value} onChange={field.onChange} />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <TextareaWithLabel<FeedbackFormType> fieldTitle="" nameInSchema="text" rows={3} />
      </form>
    </Form>
  )
}

export default FeedbackForm;
